export var WindowEvent;
(function (WindowEvent) {
    WindowEvent["BEFORE_UNLOAD"] = "beforeunload";
    WindowEvent["UNLOAD"] = "unload";
    WindowEvent["POP_STATE"] = "popstate";
})(WindowEvent || (WindowEvent = {}));
